import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading } from 'shared/components';
import { useMember } from 'shared/hooks';
/**
 * This component pulls the Spring Health Company name and practice location and displays it as a header
 */
export var SpringHealthCompanyHeader = function (_a) {
    var _b, _c;
    var memberId = _a.memberId;
    var data = useMember(memberId !== null && memberId !== void 0 ? memberId : '').data;
    var companyLocation = (_c = (_b = data === null || data === void 0 ? void 0 : data.patient_practice_location) === null || _b === void 0 ? void 0 : _b.patient_practice) === null || _c === void 0 ? void 0 : _c.name;
    return (_jsxs(Box, { children: [_jsx(Heading, { children: companyLocation }), "251 Park Ave S STE 600, New York, NY 10010-7302"] }));
};
